'use client';
import { Button } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import { useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

// Set worker source for PDF.js
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

interface ShowPDFProps {
  onClose: () => void;
  showModal: boolean;
  fileUrl: string;
}

export const ShowPDF = ({ onClose, showModal, fileUrl }: ShowPDFProps) => {
  const [numPages, setNumPages] = useState<number | null>(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [modalWidth, setModalWidth] = useState(window.innerWidth * 0.9);

  useEffect(() => {
    const handleResize = () => setModalWidth(window.innerWidth * 0.9);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages || 0);
  };

  const goToPrevPage = () => setPageNumber((prev) => Math.max(prev - 1, 1));
  const goToNextPage = () => setPageNumber((prev) => Math.min(prev + 1, numPages || 0));

  const onCancel = () => {
    onClose?.();
  };

  const pdfWidth = Math.min(modalWidth - 40, 600); // Subtract padding and limit max width

  return (
    <Modal
      open={showModal}
      onCancel={onCancel}
      footer={null}
      centered
      destroyOnHidden
      width={{
        xs: '90%',
        sm: '80%',
        md: '70%',
        lg: '60%',
        xl: '50%',
        xxl: '40%',
      }}
    >
      <div style={{ textAlign: 'center', width: '100%' }}>
        <Document file={fileUrl} onLoadSuccess={onDocumentLoadSuccess}>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Page
              pageNumber={pageNumber}
              renderMode="canvas"
              renderTextLayer={false}
              renderAnnotationLayer={false}
              width={pdfWidth}
            />
          </div>
        </Document>
        <div style={{ marginTop: '10px' }}>
          <Button onClick={goToPrevPage} disabled={pageNumber <= 1}>
            Previous
          </Button>
          <Button onClick={goToNextPage} disabled={pageNumber >= (numPages || 0)}>
            Next
          </Button>
          <p>
            Page {pageNumber} of {numPages || 0}
          </p>
        </div>
      </div>
    </Modal>
  );
};
